import React from 'react';
import logo from '../Assets/logo.png';

const CustomLazyLoading = () => {
    return (
        <div style={{ height: '100vh',  display:"flex",justifyContent:"center",alignItems:"center"}}>
            <div>
                
                <div  className='mx-4 w-100'>
                
                <img alt="Loading" src={logo} style={{width:"90%",height:"250px"}} />
                </div>
            </div>
        </div>
    )
}

export default CustomLazyLoading